import { InventoryIngredient } from "./models";

const VALID_UNITS = "g, kg, ml, l, pz, box, portion, oz, lb";
const VALID_CATEGORIES =
  "proteins, dairy, produce, bakery, dry_goods, beverages, spices, oils, frozen, packaging, cleaning, other";

const BOM = "\uFEFF";

const escapeCsvField = (value: string | number | null | undefined): string => {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n") || str.includes("\r")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const buildHeaders = (branches: { id: string; name: string }[]): string[] => {
  const base = [
    "nombre",
    "nombre_en",
    "sku",
    "unidad",
    "costo",
    "categoria",
    "alerta_stock_bajo",
    "punto_reorden",
  ];
  const stockCols = branches.map((b) => `stock_${b.name.replace(/,/g, "")}`);
  return [...base, ...stockCols];
};

export const generateCsvTemplate = (
  branches: { id: string; name: string }[]
): string => {
  const headers = buildHeaders(branches);
  const exampleRow = [
    "Harina de Trigo",
    "Wheat Flour",
    "HAR-001",
    "kg",
    "25.50",
    "dry_goods",
    "5",
    "10",
    ...branches.map(() => "0"),
  ];
  const commentRow = [
    `# Unidades válidas: ${VALID_UNITS}`,
    "",
    "",
    `Categorías válidas: ${VALID_CATEGORIES}`,
    "",
    "",
    "",
    "",
    ...branches.map(() => ""),
  ];

  return (
    BOM +
    headers.map(escapeCsvField).join(",") +
    "\n" +
    exampleRow.map(escapeCsvField).join(",") +
    "\n" +
    commentRow.map(escapeCsvField).join(",") +
    "\n"
  );
};

export const generateCsvExport = (
  ingredients: InventoryIngredient[],
  branches: { id: string; name: string }[]
): string => {
  const headers = buildHeaders(branches);
  const rows = ingredients.map((ing) => {
    const base = [
      ing.name,
      ing.name_en || "",
      ing.sku || "",
      ing.unit,
      ing.cost != null ? Number(ing.cost).toFixed(2) : "",
      ing.category || "",
      ing.low_stock_threshold != null ? String(ing.low_stock_threshold) : "",
      ing.reorder_point != null ? String(ing.reorder_point) : "",
    ];
    const stockCols = branches.map((branch) => {
      const total = (ing.locations || [])
        .filter((loc) => loc.branch_id === Number(branch.id))
        .reduce((sum, loc) => sum + (loc.quantity || 0), 0);
      return total ? total.toString() : "0";
    });
    return [...base, ...stockCols].map(escapeCsvField).join(",");
  });

  return BOM + headers.map(escapeCsvField).join(",") + "\n" + rows.join("\n") + "\n";
};

export const downloadCsv = (csvString: string, filename: string): void => {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
